<template>
  <cTable
    :fields="fields"
    :footer="footer"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import { apis } from "@/api/priceRule/dduRule";
import FreightRules from "@/view/finances/freight/rules";
import cTable from "@/base/common/index";
import { getAllClient, getCompanies } from "@/api/user/client";

export default {
  components: {
    cTable,
    FreightRules,
  },
  data() {
    return {
      methods: {
        ...apis,
        getAllClient,
        getCompanies,
      },
      config: {
        mergeRows: [
          "checkbox",
          "batch_no",
          "threshold_values",
          "use_values_type",
          "start_time",
          "end_time",
          "batch_no_",
          "from_country",
          "to_country",
          "use_values_type_txt",
          "usd_to_rate",
        ],
        mergeRow: "batch_no",
      },
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              this.$page
                .handleRequestMethods(
                  data.id ? "update" : "add",
                  data,
                  true,
                  true
                )
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 1000,
            },
            formBind: {
              labelWidth: 120,
            },
            colBind: {
              style: "margin-bottom:10px;",
            },
            rules: {
              ownership: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "any",
                  trigger: "blur",
                },
              ],
              client_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              from_country: [
                { required: true, message: "cannot be empty", trigger: "blur" },
              ],
              to_country: [
                { required: true, message: "cannot be empty", trigger: "blur" },
              ],
            },
          },
          grid: [
            { ownership: 12, client_id: 12 },
            { from_country: 12, to_country: 12 },
            { rules: 24 },
          ],
          fields: [
            {
              name: this.$t("b2bClient") + this.$t("ownership"),
              key: "ownership",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("ownership"),
              options: [],
              config: {
                label: "title",
                value: "id",
              },
              disabled: ({ row }) => {
                return !!row.id;
              },
              methods: {
                async list({ field }) {
                  field.options = [
                    {
                      title: "ALL",
                      id: "*",
                    },
                    ...(await this.$page.handleRequestMethods("getCompanies"))
                      .payload,
                  ];
                },
                "on-change"({ formData, fields }) {
                  fields.forEach(async (field) => {
                    if (
                      field.key === "client_id" &&
                      formData.ownership &&
                      formData.ownership !== "*"
                    ) {
                      formData.client_id = "";
                      field.options = [
                        {
                          label: "ALL",
                          ownership_name: "*",
                          value: "*",
                        },
                        ...(
                          await this.$page.handleRequestMethods(
                            "getAllClient",
                            {
                              ownership: formData.ownership,
                            }
                          )
                        ).payload.rows.map((t) => {
                          t.label = t.account;
                          t.value = t.id;
                          return t;
                        }),
                      ];
                    }
                  });
                },
              },
            },
            {
              name: this.$tz("客户名称"),
              key: "client_id",
              component: "Select",
              placeholder: () => this.$tz("客户名称"),
              options: [],
              optionsFn: "getAllClientALL",
              optionsKey: "",
              default: "",
              disabled: ({ row }) => {
                return !!row.id;
              },
            },
            {
              name: this.$tz("起运国"),
              key: "from_country",
              component: "Select",
              placeholder: () => this.$tz("起运国"),
              options: [],
              optionsFn: "AllFormCountry",
              optionsKey: "",
              default: "",
            },
            {
              name: this.$tz("目的国"),
              key: "to_country",
              component: "Select",
              placeholder: () => this.$tz("目的国"),
              options: [],
              optionsFn: "toCountry",
              optionsKey: "",
              default: "",
            },
            {
              name: this.$tz("税费规则"),
              key: "rules",
              render: (h, p) => {
                return h(FreightRules, {
                  props: {
                    single: true,
                    rows: this.$refs["table"].getModal("add").params,
                  },
                });
              },
              default: [],
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "start_time",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "end_time",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "from_country",
            placeholder() {
              return this.$tz("起运国");
            },
            component: "Select",
            options: [],
            optionsFn: "formCountry",
            optionsKey: "",
          },
          {
            key: "to_country",
            placeholder() {
              return this.$tz("目的国");
            },
            component: "Select",
            options: [],
            optionsFn: "toCountry",
            optionsKey: "",
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
            },
            {
              name: () => this.$tz("删除"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
            },
          ],
          methods: {
            add() {
              this.getModal("add").open({ rules: [] }, function () {
                this.setTitle(this.$tz("新增"));
              });
            },
            delete() {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "delete",
                    { batch_no: this.selectAll.map((t) => t.batch_no) },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center",
          fixed: "left",
          key: "checkbox",
        },
        {
          name: () => this.$t("batch_number"),
          key: "batch_no",
          minWidth: 130,
        },
        {
          key: "start_time",
          name: () => this.$t("start") + this.$t("time"),
          // component: "DatePicker",
          minWidth: 200,
        },
        {
          key: "end_time",
          name: () => this.$t("end") + this.$t("time"),
          // component: "DatePicker",
          minWidth: 200,
        },

        {
          name: () => this.$tz("起运国"),
          key: "from_country",
          minWidth: 130,
        },
        {
          name: () => this.$tz("目的国"),
          key: "to_country",
          minWidth: 130,
        },
        {
          name: () => this.$t("Threshold Values"),
          key: "threshold_values",
          minWidth: 170,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Declared Currency Type"),
          key: "use_values_type_txt",
          minWidth: 170,
          // component: "Select",
          default: 1,
          methods: {
            list({ field }) {
              field.options = [
                { label: this.$t("Fixed USD"), value: 1 },
                { label: this.$t("Destination Currency"), value: 2 },
              ];
            },
          },
        },
        {
          name: () => this.$t("Threshold Type"),
          key: "threshold_type",
          minWidth: 130,
          methods: {
            render({ value }) {
              return value == 1 ? this.$t("Low") : this.$t("High");
            },
          },
        },
        {
          name: () => this.$t("USD To Destination Currency Rate"),
          key: "usd_to_rate",
          minWidth: 160,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
            min: 0,
            step: 0.1,
          },
        },
        {
          name: () => this.$tz("费用,币种"),
          key: "currency",
          minWidth: 110,
        },
        {
          name: () => this.$t("Duty Rate"),
          key: "duty_rate",
          minWidth: 130,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
            max: 100,
            min: 0,
            step: 0.1,
            formatter: (value) => `${value}%`,
            parser: (value) => value.replace("%", ""),
          },
        },
        {
          name: () => this.$t("VATRate"),
          key: "vat_rate",
          minWidth: 130,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
            max: 100,
            min: 0,
            step: 0.1,
            formatter: (value) => `${value}%`,
            parser: (value) => value.replace("%", ""),
          },
        },
        {
          name: () => this.$t("Paper Fee") + "/USD",
          key: "paper_fee_usd",
          minWidth: 140,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Paper Fee") + "/" + this.$t("allow_arrive"),
          key: "paper_fee",
          minWidth: 150,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
          // disabled:true,
        },
        {
          name: () => this.$t("Insurance Rate"),
          key: "insurance_rate",
          minWidth: 130,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
            max: 100,
            min: 0,
            step: 0.1,
            formatter: (value) => `${value}%`,
            parser: (value) => value.replace("%", ""),
          },
        },

        {
          name: () => this.$t("bayan"),
          key: "bayan",
          minWidth: 130,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Clearance Fee"),
          key: "clearance_fee",
          minWidth: 130,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("HandlingFee"),
          key: "handling_fee",
          minWidth: 130,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Administration fee"),
          key: "administration_fee",
          minWidth: 130,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Bank Fee"),
          key: "bank_fee",
          minWidth: 130,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Legalization Fee"),
          key: "legalization_fee",
          minWidth: 130,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Global Fee"),
          key: "global_fee",
          minWidth: 130,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Nas Handle Price"),
          key: "nas_handle_price",
          minWidth: 140,
          // component: "InputNumber",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        {
          name: () => this.$t("Nas Handle Unit"),
          key: "nas_handle_unit",
          minWidth: 130,
        },

        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 140,
          // component: "Input",
          default: 0,
          bind: {
            style: "width:100%",
          },
        },
        //    {
        //      name: () => this.$t("start") + this.$t("date"),
        //      key: "start_time",
        //      width: 140,
        // component:'DatePicker'
        //    },
        //    {
        //      name: () => this.$t("end") + this.$t("date"),
        //      key: "end_time",
        //      width: 140,
        // component:'DatePicker'
        //    },
        {
          type: "btns",
          key: "batch_no_",
          width: 120,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$tz("更新"),
              type: "update",
              fnName: "update",
              bind: {
                type: "primary",
              },
            },
          ],

          methods: {
            update({ row, rowIndex }) {
              this.handleRequestMethods(
                "detail",
                { id: row.batch_no },
                false,
                true
              ).then((res) => {
                res.payload.id = res.payload.batch_no;
                this.getModal("add").open(res.payload, function () {
                  this.setTitle(this.$tz("更新"));
                });
              });
            },
          },
        },
      ],
    };
  },
};
</script>
